/**
 * SmartInboxTab — 3-column layout for the smart/domain-bundled inbox view.
 *
 * FolderSidebar (140px) | DomainBundleList (32%) | DomainDetailPane (flex-1)
 *
 * Replaces InboxTab when InboxShell variant="smart".
 */
import React, { useMemo } from 'react';
import { FolderSidebar } from '../sidebar/FolderSidebar';
import { DomainBundleList } from './DomainBundleList';
import { DomainDetailPane } from './DomainDetailPane';
import { useDomainBundles } from './useDomainBundles';
import { useInbox } from '../InboxContext';

function SmartInboxTab() {
  const { folderEmails, selectedDomain } = useInbox();

  const bundles = useDomainBundles(folderEmails);

  const selectedBundle = useMemo(
    () => bundles.find((b) => b.domainKey === selectedDomain) ?? null,
    [bundles, selectedDomain],
  );

  return (
    <div style={{ display: 'flex', position: 'absolute', inset: 0 }}>
      {/* Folder sidebar */}
      <div style={{ width: 140, flexShrink: 0, borderRight: '1px solid var(--surface)', overflowY: 'auto' }}>
        <FolderSidebar />
      </div>

      {/* Domain bundle list */}
      <div style={{ width: '32%', flexShrink: 0, display: 'flex', flexDirection: 'column', borderRight: '1px solid var(--surface)', minWidth: 0 }}>
        <DomainBundleList bundles={bundles} />
      </div>

      {/* Domain detail pane */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <DomainDetailPane bundle={selectedBundle} />
      </div>
    </div>
  );
}

export { SmartInboxTab };
